/* eslint-disable no-unused-vars */
export enum AppRoutes {
	Login = '/login',
	Objects = '/objects',
	Vocabulary = '/vocabulary',
	Passes = '/passes',
	PassTypes = '/passtypes',
	Security = '/security',
	CarAccess = '/caraccess',
	About = '/about',
	Restrictions = '/restrictions',
	Bookings = '/bookings',
	AllBookings = '/allbookings',
	PersonalPlaces = '/places',
	Settings = '/settings',
	References = '/references',
	Renters = '/renters',
	Help = '/help',
	ScudMapping = '/scud-mapping',

	/*Bookings*/
	BookingNew = '/new',
	BookingEdit = `/bookings/:id/edit`,

	/*Rating*/
	Rating = '/rating',
	RatedBookings = 'rated-bookings',

	/*Statistics*/
	Statistics = '/statistics',
}
